export default function () {
  return {
    dashboard: {
      loading: true,
      pedidos: {},
      pedidosAtrasados: {},
    },
  };
}
